"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = require("styled-components");
var Basic = styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n  overflow: hidden;\n  text-align: left;\n  position: absolute;\n  text-decoration: none;\n"], ["\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n  overflow: hidden;\n  text-align: left;\n  position: absolute;\n  text-decoration: none;\n"])));
exports.default = Basic;
var templateObject_1;
//# sourceMappingURL=basic.js.map